import { call } from '../core'

export interface INativeInfo {
  authToken: string
  deviceId: string
  lineAccessToken: string
  osModel: string
  osVersion: string
  language: string
  applicationId: string
}

export const EmptyNativeInfo: INativeInfo = {
  authToken: '',
  deviceId: '',
  lineAccessToken: '',
  osModel: '',
  osVersion: '',
  language: '',
  applicationId: '',
}

export interface INativeInfoResult {
  result: INativeInfo | null
}

export function getNativeInfo(): Promise<INativeInfoResult | Error> {
  return call('finGetNativeInfo')
}
